import React, { useContext, useState } from "react";
import Im from "immutable";
import { BSCard, prefixProtocol, postFetch } from "../utils";
import LoginForm from "../login";
import { FormNonFieldErrors } from "./utils";
import { InputField } from "../formItems";
import { AuthContext } from "../context";

function ResetConfirmDone() {
  return (
    <>
      <p>
        Your password reset is complete. You may now log in with your new
        password.
      </p>
      <LoginForm hideCreateAccount />
    </>
  );
}

const submitPasswordResetConfirm = (
  e,
  uid,
  token,
  host,
  setStatus,
  setErrors,
) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const passwordData = Object.fromEntries(formData.entries());
  const data = { uid, token, ...passwordData };
  console.log("submitPasswordResetConfirm", host, data);
  postFetch({
    url: `${prefixProtocol(host)}/auth-rest/password/reset/confirm/`,
    data,
    onSuccess: () => setStatus("confirmed"),
    onFailure: (data) => setErrors(Im.fromJS(data)),
  });
};

function PasswordResetConfirmForm({ uid, token, setStatus }) {
  const [errors, setErrors] = useState(null);
  const { host } = useContext(AuthContext);
  console.log("PasswordResetConfirmForm", errors?.toJS());
  return (
    <form
      className="form"
      onSubmit={(e) =>
        submitPasswordResetConfirm(e, uid, token, host, setStatus, setErrors)
      }
    >
      <FormNonFieldErrors errors={errors} />
      <InputField
        attribute="new_password1"
        placeholder="New Password"
        fieldType="password"
        errors={errors}
      />
      <InputField
        attribute="new_password2"
        placeholder="New Password (again)"
        fieldType="password"
        errors={errors}
      />

      <div
        style={{ marginTop: "-1em", marginLeft: "0.25em" }}
        className="form-group"
      >
        <small className="text-muted">
          <b>
            All passwords must contain at least 12 characters, one uppercase,
            one special character and one numeric character. It also cannot be
            similar to parts of your name or email address.
          </b>
        </small>
      </div>

      <div className="form-group">
        <button className="btn btn-sm btn-primary btn-block" type="submit">
          Set new password
        </button>
      </div>
    </form>
  );
}

export default function PasswordResetConfirmPage(props) {
  const { uid, token } = props.match.params;
  const [status, setStatus] = useState("");

  let title = "Enter a new password";
  let body = (
    <PasswordResetConfirmForm uid={uid} token={token} setStatus={setStatus} />
  );

  // If we have submitted the form then show a confirmation
  if (status === "confirmed") {
    title = "Password reset Complete";
    body = <ResetConfirmDone />;
  }

  return (
    <div className="container">
      <div className="col-sm-8 offset-sm-2 mt-3">
        <BSCard title={title} body={body} />
      </div>
    </div>
  );
}
